import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { TextArea as AntdTextArea, NewTextArea } from 'components/atoms/input/text-area';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';
const TextAreaComponent = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const isNewDesignEnabled = useAntdRlUISwitcher();
    if (isNewDesignEnabled) {
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ _jsx(NewTextArea, {
            ...props,
            ref: ref
        });
    }
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ _jsx(AntdTextArea, {
        ...props,
        ref: ref
    });
});
TextAreaComponent.displayName = 'TextAreaComponent';
// Create a styled component to enable CSS interpolation like ${TextArea}
export const TextArea = styled(TextAreaComponent)``;
TextArea.displayName = 'TextArea';
